import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../AxiosOrders";

export const getIncomeReport = createAsyncThunk('income/report', async (intakeId, { rejectWithValue }) => {
    try {
        const { data } = await instance.get(`/reports/intakes/${intakeId}/income`);
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});
